var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center text-sm gap-2"},[(_vm.status)?_c('div',{staticClass:"h-2 w-2 rounded-full",class:_vm.statusStyling.background}):_vm._e(),_vm._t("status",function(){return [(_vm.showStatus)?_c('p',{staticClass:"capitalize"},[_vm._v(" "+_vm._s(_vm.status ? _vm.status : '-')+" ")]):_vm._e()]},{"status":_vm.status})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }